export function createEvent({
    bteId,
    exchangeId,
    name,
    date,
    primaryEventUrl,
    performers,
    venue,
    eventLimitNumberOfTickets,
    eventLimit1PurchasePerBuyer,
    runLimit1PurchasePerBuyer,
    runLimitNumberOfTickets,
    useRunLevelLimit,
    runId,
    runEventIds,
    salesDates,
    entityLink
  }) {
    return {
      bteId,
      exchangeId,
      name,
      date,
      primaryEventUrl,
      performers,
      venue,
      eventLimitNumberOfTickets,
      eventLimit1PurchasePerBuyer,
      runLimit1PurchasePerBuyer,
      runLimitNumberOfTickets,
      useRunLevelLimit,
      runId,
      runEventIds,
      salesDates,
      entityLink
    };
  }
  